module.exports = __webpack_public_path__ + "img/powered2.d71a559c.png";